import type { ProductData, CategoryAttributes } from '../services';
import type { IProductSeo } from '../types';
import { productDataTransformer } from './dataTransformer';
import { categoryListTransformer } from './plpTransformer';

const productSeoTransformer = (productData: ProductData): IProductSeo => {
  const { productName, mainLink, seoDescription, seoTitle } = productDataTransformer(productData);
  return {
    title: seoTitle || productName,
    image: {
      url: mainLink || '',
    },
    description: seoDescription || productName,
  };
};

const PLPSEOTransformer = (cateogoryData: CategoryAttributes, lang: string): IProductSeo => {
  const { title, imageLink, description } = categoryListTransformer(cateogoryData, lang);
  return {
    title,
    image: {
      url: imageLink || '',
    },
    description: description || title,
  };
};

export { productSeoTransformer, PLPSEOTransformer };
